var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_866_7685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0V35H35V0H0ZM25.1776 4.56727C25.4318 4.56187 25.6965 4.57013 25.9702 4.58862C26.9757 4.58999 28.0259 4.68064 29.0677 4.77234L28.9545 8.91663H26.156C24.8438 8.88758 24.37 9.39709 24.3274 10.8777V14.1333H29.0677L28.8797 18.5724H24.3274V30.9305H19.7025V18.5724H16.4917V14.1333H19.7025V10.3223C19.7025 7.5745 20.8641 5.82552 23.1525 4.93897C23.7402 4.70773 24.415 4.58345 25.1776 4.56727Z",
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_866_7685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialFacebook);
export default __webpack_public_path__ + "static/media/social Facebook.4036e8303aed5ef3853232e501a0ff7b.svg";
export { ForwardRef as ReactComponent };